import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ActiveToast, ToastService } from '../../../services/toast.service';

/**
 * Renders the toast stack (top-right, newest at the bottom of the stack).
 *
 * Mounted once, unconditionally, in app.component.html — toasts must show on
 * public routes (login errors) as well as inside the app shell. Replaces the
 * `<p-toast>` elements that the Material migration removed.
 */
@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [NgClass, NgTemplateOutlet],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ToastContainerComponent {
  private readonly toastService = inject(ToastService);

  readonly toasts = this.toastService.toasts;

  templateFor(toast: ActiveToast) {
    return this.toastService.templateFor(toast.key);
  }

  onClose(toast: ActiveToast): void {
    this.toastService.dismiss(toast.id);
  }
}
